import { environment } from "../../../environments/dev.environment"

export const LookUpAPI = {
    GET_ALL_COUNTRIES_API: `${environment.apiUrl}lookup/country/get/all`, // Get All Countries API // GET
    GET_ALL_STATES_API: `${environment.apiUrl}lookup/state/get/all`, // Get All States API // GET
    GET_ALL_CITIES_API: `${environment.apiUrl}lookup/city/get/all` // Get All Cities API // GET
}

export const ProjectAPI = {
    CREATE_PROJECT_API: `${environment.apiUrl}project/create/project-settings`, // Create Project API // POST
    GET_ALL_PROJECTS_API: `${environment.apiUrl}project/get/all`, // Get All Projects API // POST
    GET_PROJECT_BY_PROJECT_ID_API: `${environment.apiUrl}project/get`, // Get Project by ProjectId API // GET
    UPDATE_SYSTEM_DESIGN_API: `${environment.apiUrl}project/update/design-solution`, // Update System Design API // POST
    SHARE_PROJECT_API: `${environment.apiUrl}project/share`, // Share Project API // POST
    COPY_PROJECT_API: `${environment.apiUrl}project/copy`, // Copy Project API // POST
    UPDATE_LWT_RANGES_API: `${environment.apiUrl}project/update/lwt` // Update LWT Ranges API // POST
}

export const UserAPI = {
    GET_CURRENT_USER_API: `${environment.apiUrl}auth/get/currentuser`, // Get Current User API // GET
    UPDATE_LANGUAGE_API: `${environment.apiUrl}user/change-language`, // Update Language API // POST
    UPDATE_UNIT_OF_MEASURES_API: `${environment.apiUrl}user/update-units`, // Update UOM API/ POST
    UPDATE_CALCULATION_PATAMETERS_API: `${environment.apiUrl}user/update-calculation-parameters` // Update Calculation Parameters API // POST
}

export const Logger = {
    SAVE_LOG: `${environment.apiUrl}ui-logs`, // save log // POST
}

export const ProductAPI = {
    GET_ALL_PRODUCTS_API: `${environment.apiUrl}product/get/all`, // Get All Projects API // POST
    UPDATE_PRODUCT_API: `${environment.apiUrl}product/update`, // Update Product API // POST
    GET_OUTDOOR_UNITS_API: `${environment.apiUrl}product/get/outdoor-unit` // Get Outdoor Units API // GET
}

export const QuoteAPI = {
    ADD_QUOTE_API: `${environment.apiUrl}quote/add`, // Add Quote API // POST
    LINK_QUOTE_API: `${environment.apiUrl}quote/link`, // Link Quote API // POST
    GET_QUOTE_DETAILS_API: `${environment.apiUrl}quote/details`, // Get DC quote's project/quote details // GET
}

export const DcProjectAPI = {
    GET_DC_PROJECTS_API: `${environment.apiUrl}dc-project/list`, // Get user's Daikin City projects & quotes // GET
}

export const ReportAPI = {
    DOWNLOAD_REPORT_API: `${environment.apiUrl}report/download-report`, //  Download Report API // GET
    DOWNLOAD_MATERIAL_LIST_API: `${environment.apiUrl}report/download-material-list`, //  Download Material List CSV API // GET
    DOWNLOAD_MECHANICAL_SCHEDULE_API: `${environment.apiUrl}report/download-mechanical-schedule`, //  Download Mechanical Schedule Excel API // GET
}

export const EmitterApi = {
    DELETE_EMITTER_API: `${environment.apiUrl}emitter/delete`, // Delete Emitter API // GET
    UPDATE_EMITTER_API: `${environment.apiUrl}emitter/update`, // Update Emitter API // POST
    GET_ALL_EMITTER_API: `${environment.apiUrl}emitter/get/all`, // get Emitter API // GET
}
